import { FormattedMessage } from 'react-intl';

export default function CartHeader() {
  const now = new Date().toDateString().split(' ');
  const date = {
    day: now[2],
    month: now[1],
    year: now[3]
  };

  return (
    <div className="w-full h-[132px] px-[30px] pt-[40px] pb-[20px] flex flex-col border-b border-[#f5f5f5] gap-2">
      <span className="text-[30px] leading-9 font-extrabold">
        <FormattedMessage id="order_cart_title" defaultMessage="Order summary" />
      </span>
      <div className="flex flex-col">
        <span className="text-[18px] leading-[26px] font-medium">
          <FormattedMessage id="order_cart_date" defaultMessage="Order Date" />: {`${date.month} ${date.day}, ${date.year}`}
        </span>
      </div>
    </div>
  );
}
